import { render, staticRenderFns } from "./style.vue?vue&type=template&id=3983ca50&"
import script from "./style.vue?vue&type=script&lang=ts&"
export * from "./style.vue?vue&type=script&lang=ts&"
import style0 from "./style.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports